'use client';

import { useState, useEffect } from 'react';
import {
    getProductCard,
    PRODUCT_GROUP_SOURCE_TYPE,
    PRODUCT_GROUP_SORTING_TYPE,
} from 'apis/product';

interface useProductSuggestionProps {
    productId: string;
    isBuyer?: boolean;
}

export const useProductSuggestion = (props: useProductSuggestionProps) => {
    const { productId, isBuyer = false } = props;

    const [productCards, setProductCards] = useState<ProductCard[]>([]);

    const [isLoading, setIsLoading] = useState(isBuyer);

    useEffect(() => {
        (async () => {
            setIsLoading(true);

            const resp = await getProductCard({
                type: PRODUCT_GROUP_SOURCE_TYPE.RECOMMEND,
                query: productId,
                order_by: PRODUCT_GROUP_SORTING_TYPE.POPULARITY,
                per_page: 20,
            });

            if (resp?.data) {
                setProductCards(resp.data);
            }

            setIsLoading(false);
        })();
    }, [productId]);

    return {
        productCards,
        isLoading,
    };
};
